/**
 * Values aligned with backend enums for POST /scheduleMatch.
 * PitchType: backend normalizes via PitchType.fromString().
 */

export const TOURNAMENT_CATEGORY_OPTIONS = [
  { value: "OPEN", label: "Open" },
  { value: "CORPORATE", label: "Corporate" },
  { value: "COMMUNITY", label: "Community" },
  { value: "COLLEGE", label: "College" },
  { value: "SCHOOL", label: "School" },
  { value: "SERIES", label: "Series" },
  { value: "UNIVERSITY", label: "University" },
  { value: "OTHER", label: "Other" },
] as const;

export const PITCH_TYPE_OPTIONS = [
  { value: "Rough", label: "Rough" },
  { value: "Cement", label: "Cement" },
  { value: "Matting", label: "Matting" },
  { value: "Turf", label: "Turf" },
  { value: "Astroturf", label: "Astroturf" },
] as const;

export const MATCH_TYPE_OPTIONS = [
  { value: "LIMITED_OVERS", label: "Limited overs" },
  { value: "TEST", label: "Test" },
  { value: "T10", label: "T10" },
  { value: "T20", label: "T20" },
] as const;

/** Sent as playoffType; backend maps LEAGUE_MATCHES → LEAGUE_MATCH if ever received. */
export const PLAYOFF_TYPE_OPTIONS = [
  { value: "LEAGUE_MATCH", label: "League Match" },
  { value: "FINAL", label: "Final" },
  { value: "SEMI_FINAL", label: "Semi Final" },
  { value: "SEMI_FINAL_QUALIFIER", label: "Semi Final Qualifier" },
  { value: "QUARTER_FINAL", label: "Quarter Final" },
  { value: "QUALIFIER", label: "Qualifier" },
  { value: "ELIMINATOR", label: "Eliminator" },
] as const;

const PITCH_VALUE_SET = new Set(
  PITCH_TYPE_OPTIONS.map((o) => o.value),
);

/** Map common UI / legacy tokens to PitchType enum strings. */
export function normalizePitchTypeForSchedule(raw: string): string {
  const t = raw.trim();
  if (!t) return t;
  if (PITCH_VALUE_SET.has(t)) return t;
  const lower = t.toLowerCase();
  const aliases: Record<string, string> = {
    rough: "Rough",
    cement: "Cement",
    matting: "Matting",
    turf: "Turf",
    astroturf: "Astroturf",
    astro: "Astroturf",
  };
  return aliases[lower] ?? t;
}

const PLAYOFF_VALUE_SET = new Set(PLAYOFF_TYPE_OPTIONS.map((o) => o.value));

/** Normalize legacy / loose tokens to the backend enum strings. */
export function normalizePlayoffTypeForSchedule(raw: string): string {
  const t = raw.trim();
  if (!t) return t;
  if (PLAYOFF_VALUE_SET.has(t)) return t;
  const upper = t.toUpperCase().replace(/\s+/g, "_");
  if (PLAYOFF_VALUE_SET.has(upper)) return upper;
  const aliases: Record<string, string> = {
    LEAGUE: "LEAGUE_MATCH",
    LEAGUE_MATCHES: "LEAGUE_MATCH",
    KNOCKOUT: "FINAL",
  };
  return aliases[upper] ?? t;
}
